import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { getById } from '../../lib/RestApi/customApiHandler'
import AddChannelTypeMaster from './AddChannelTypeMaster'
export default function EditChannelTypeMaster() {
  const params = useParams()
  const [channelTypeMaster, setChannelTypeMaster] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getById('/channel/types', params.channelTypeMasterId).then((res) => {
      setChannelTypeMaster(res.data)
      setLoading(false)
    })
  }, [params.channelTypeMasterId])

  return <> {loading ? <Loader /> : <AddChannelTypeMaster channelTypeMaster={channelTypeMaster} />} </>
}
